import React, { Fragment, memo, useEffect, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import {
  Collapse,
  Drawer,
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Badge,
  Box,
  Typography,
  CardMedia,
} from "@mui/material";
import { ChevronRight, ExpandLess, ExpandMore, Menu, MenuOpen } from "@mui/icons-material";
import { styled } from "@mui/material/styles";

// *Imported Components
import Images from "../Assets/Images/Images";
import Colors from "../Assets/Styles/Colors";
import Navigation from "../../Navigation";

const DrawerHeader = styled("div")(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  marginLeft: "12px",
  marginRight: "7px",
  // necessary for content to be below app bar
  ...theme.mixins.toolbar,
}));

const drawerWidth = 290;

const SideNav = ({ onClick, status }) => {
  const { pathname } = useLocation();
  const navigate = useNavigate();

  const [expand, setExpand] = useState([]);
  // const [nestedExpand, setNestedExpand] = useState(false);
  const [nestedExpand, setNestedExpand] = useState([]);
  const role = localStorage.getItem("role");

  // *For Active
  // const handleSubChildActive = (item) => {
  //   return (
  //     item.childPath?.indexOf(pathname) !== -1 &&
  //     item.childPath?.indexOf(pathname)
  //   );
  // };

  // const handleToggleSubMenu = (index) => {
  //   setExpand((prevState) => ({
  //     ...prevState,
  //     [index]: !prevState[index],
  //   }));
  // };

  // const handleToggleSubMenu = (index) => {
  //   setExpand((prevState) => {
  //     const updatedExpand = [...prevState];
  //     updatedExpand[index] = !updatedExpand[index];
  //     return updatedExpand;
  //   });
  // };

  const handleToggleSubMenu = (index, data) => {
    let name = data.label;
    setExpand((prevExpand) => ({
      [name]: !prevExpand[name]
    }));
  };

  const handleToggleNestedSubMenu = (data) => {
    let name = data.label;
    setNestedExpand((prevExpand) => ({
      [name]: !prevExpand[name]
    }));
  }

  useEffect(() => {
    Navigation.forEach((item) => {
      item?.subMenu?.forEach((subItem) => {
        if (subItem.path == pathname) {
          setExpand(() => ({
            [item.label]: true
          }));
        }
      })
    });
  }, [status]);

  useEffect(() => {
    Navigation.forEach((item) => {
      item?.subMenu?.forEach((subItem) => {
        subItem?.subMenu?.forEach((nestedSubItem) => {
          if (nestedSubItem.path == pathname) {
            setExpand(() => ({
              [item.label]: true
            }));
            setNestedExpand(() => ({
              [subItem.label]: true
            }));
          }
        })
      })
    });
  }, [status]);

  return (
    <Drawer
      sx={{
        width: status ? drawerWidth : 50,
        transition: 'width 0.5s ease-in-out !important',
        flexShrink: 0,
        "& .MuiDrawer-paper": {
          width: status ? drawerWidth : 50,
          transition: 'width 0.5s ease-in-out !important',
          // width: drawerWidth,
          boxSizing: "border-box",
          background: Colors.primaryGradient,
          color: Colors.white,
          overflowY: status && "scroll",
          "&::-webkit-scrollbar": {
            width: 6,
            bgcolor: "transparent",
          },
          "&::-webkit-scrollbar-thumb": {
            borderRadius: 1,
            bgcolor: Colors.white,
          },
        },
      }}
      variant="permanent"
      anchor="left"
    >
      {status ? (
        <Fragment>
          <DrawerHeader>
            <CardMedia component={"img"} src={Images.logo} alt="logo-adstreet"
              sx={{
                width: "200px",
                objectFit: "contain"
              }}
            />
            <Box sx={{ display: "flex", alignItems: 'center' }}>
              <MenuOpen onClick={onClick} sx={{ fontSize: '30px', cursor: 'pointer', color: Colors.white }} />
            </Box>
          </DrawerHeader>
          <List>
            {Navigation.map((item, index) => item.subMenu ? (
              <Fragment key={index}>
                <ListItem key={index}
                  button
                  onClick={() => {
                    handleToggleSubMenu(index, item);
                  }}
                  sx={{
                    borderRadius: 2,
                    mx: 1,
                    mt: 1.5,
                    width: "94%",
                    "&.Mui-selected": {
                      bgcolor: Colors.white,
                      color: Colors.primary,
                      ":hover": {
                        backgroundColor: Colors.white,
                        color: Colors.primary,
                      },
                    },
                    ":hover": {
                      backgroundColor: Colors.white,
                      color: Colors.primary,
                    },
                  }}
                  disablePadding>
                  <ListItemButton
                    selected={
                      pathname === item.path
                        ? true
                        : false
                    }
                    onClick={() => {
                      if (item.path) {
                        navigate(item.path);
                      }
                    }}
                  >
                    <ListItemIcon
                      sx={{
                        minWidth: 0,
                        mr: 4,
                        justifyContent: "center",
                        bgcolor: Colors.white,
                        borderRadius: "6px",
                      }}
                    >
                      {item.icon}
                    </ListItemIcon>
                    <ListItemText
                      primary={item.label}
                    />
                    {expand[item.label] ? <ExpandLess /> : <ExpandMore />}
                  </ListItemButton>
                </ListItem>
                <Collapse
                  in={expand[item.label]}
                  // onClick={}
                  key={index}>
                  <List key={index}>
                    {item.subMenu.map((subItem, subIndex) => subItem.subMenu ? (
                      <Fragment key={subIndex}>
                        <ListItem key={subIndex}
                          sx={{
                            borderRadius: 2,
                            width: "94%",
                            mx: 1,
                            mb: 1.5,
                            "&.Mui-selected": {
                              bgcolor: Colors.white,
                              color: Colors.primary,
                              ":hover": {
                                backgroundColor: Colors.white,
                                color: Colors.primary,
                              },
                            },
                            ":hover": {
                              backgroundColor: Colors.white,
                              color: Colors.primary,
                            },
                          }}
                          onClick={() => {
                            handleToggleNestedSubMenu(subItem)
                          }}
                          disablePadding
                        >
                          <ListItemButton>
                            {nestedExpand[subItem.label] ? <ExpandLess /> : <ExpandMore />}
                            <ListItemIcon
                              sx={{
                                minWidth: 0,
                                ml: 2,
                                mr: 4,
                                justifyContent: "center",
                                bgcolor: Colors.white,
                                borderRadius: "6px",
                              }}
                            >
                              {subItem.icon}
                            </ListItemIcon>
                            <ListItemText primary={subItem.label} />
                          </ListItemButton>
                        </ListItem>
                        <Collapse in={nestedExpand[subItem.label]} key={index}>
                          <List key={subIndex}>
                            {subItem.subMenu.map((nestedSubItem, nestedSubIndex) => (
                              <ListItem
                                key={nestedSubIndex}
                                button
                                selected={pathname === nestedSubItem.path}
                                onClick={() => {
                                  navigate(nestedSubItem.path);
                                }}
                                sx={{
                                  borderRadius: 2,
                                  width: "94%",
                                  mx: 1,
                                  mb: 1.5,
                                  "&.Mui-selected": {
                                    bgcolor: Colors.white,
                                    color: Colors.primary,
                                    ":hover": {
                                      backgroundColor: Colors.white,
                                      color: Colors.primary,
                                    },
                                  },
                                  ":hover": {
                                    backgroundColor: Colors.white,
                                    color: Colors.primary,
                                  },
                                }}
                              >
                                <ListItemIcon
                                  sx={{
                                    minWidth: 0,
                                    ml: 2,
                                    mr: 4,
                                    justifyContent: "center",
                                    bgcolor: Colors.white,
                                    borderRadius: "6px",
                                  }}
                                >
                                  {nestedSubItem.icon}
                                </ListItemIcon>
                                <ListItemText primary={nestedSubItem.label} />
                              </ListItem>
                            ))}
                          </List>
                        </Collapse>
                      </Fragment>
                    ) : (
                      <ListItem
                        key={subIndex}
                        button
                        selected={pathname === subItem.path}
                        onClick={() => {
                          navigate(subItem.path);
                        }}
                        sx={{
                          borderRadius: 2,
                          width: "94%",
                          mx: 1,
                          mb: 1.5,
                          "&.Mui-selected": {
                            bgcolor: Colors.white,
                            color: Colors.primary,
                            ":hover": {
                              backgroundColor: Colors.white,
                              color: Colors.primary,
                            },
                          },
                          ":hover": {
                            backgroundColor: Colors.white,
                            color: Colors.primary,
                          },
                        }}
                      >
                        <ListItemIcon
                          sx={{
                            minWidth: 0,
                            ml: 2,
                            mr: 4,
                            justifyContent: "center",
                            bgcolor: Colors.white,
                            borderRadius: "6px",
                          }}
                        >
                          {subItem.icon}
                        </ListItemIcon>
                        <ListItemText primary={subItem.label} />
                      </ListItem>
                    ))}
                  </List>
                </Collapse>
              </Fragment>
            ) : (
              <ListItem key={index} disablePadding>
                <ListItemButton
                  selected={
                    pathname === item.path
                      ? true
                      : false
                  }
                  onClick={() => {
                    navigate(item.path);
                  }}
                  sx={{
                    borderRadius: 2,
                    mx: 1,
                    mt: 1.5,
                    "&.Mui-selected": {
                      bgcolor: Colors.white,
                      color: Colors.primary,
                      ":hover": {
                        backgroundColor: Colors.white,
                        color: Colors.primary,
                      },
                    },
                    ":hover": {
                      backgroundColor: Colors.white,
                      color: Colors.primary,
                    },
                  }}
                >
                  <ListItemIcon
                    sx={{
                      minWidth: 0,
                      mr: 4,
                      justifyContent: "center",
                      bgcolor: Colors.white,
                      borderRadius: "6px",
                    }}
                  >
                    {item.icon}
                  </ListItemIcon>
                  <ListItemText
                    primary={item.label}
                    primaryTypographyProps={{}}
                  />
                </ListItemButton>
              </ListItem>
            ))}
          </List>
        </Fragment>
      ) : (
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            position: "relative",
            zIndex: 11111111,
            top: "20px",
          }}
        >
          <Menu onClick={onClick}
            sx={{
              fontSize: '25px',
              cursor: 'pointer',
              color: Colors.white,
            }}
          />
        </Box>
      )}
    </Drawer >
  );
};

export default SideNav;
